import { svg } from 'lit';

const symbol = svg`<svg width="17" height="17" viewBox="0 0 576 512" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 128c0-35.3 28.7-64 64-64h256c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm559.1-28.2c10.4 5.6 16.9 16.4 16.9 28.2v256c0 11.8-6.5 22.6-16.9 28.2s-23 5-32.9-1.6l-96-64-14.2-9.5V191.9l14.2-9.5 96-64c9.8-6.5 22.4-7.2 32.9-1.6z" stroke="#F5F5F5"/></svg>`;

export { symbol as default };
